// client/src/lib/hooks/useProjects.ts
import { useEffect, useState } from "react";
import { apiGet } from "../../lib/api";

export type Project = {
  id: string; title: string; description: string; status: "planned"|"in_progress"|"completed"|"archived";
  is_team_project: boolean; associated_with?: string | null; start_date?: string | null; end_date?: string | null;
  media?: any; owner_user_id?: string | null;
};

export function useProjects(params?: { status?: Project["status"]; is_team_project?: boolean }) {
  const [data, setData] = useState<Project[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const qs = new URLSearchParams();
    if (params?.status) qs.set("status", params.status);
    if (typeof params?.is_team_project === "boolean") qs.set("is_team_project", String(params.is_team_project));
    const url = qs.toString() ? `/api/projects?${qs.toString()}` : "/api/projects";

    (async () => {
      setLoading(true); setError(null);
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Fetch projects failed: ${res.status}`);
        setData(await res.json());
      } catch (e:any) { setError(e.message); }
      finally { setLoading(false); }
    })();
  }, [params?.status, params?.is_team_project]);

  return { data, loading, error };
}

export type PreviewMedia = {
  id: string;
  media_type: "image" | "video" | "gif" | "youtube";
  url: string;
  position?: number | null;
};

export type PreviewSlot = {
  id: string;
  position: number;
  project: { id: string; title: string; description: string };
  override_title?: string | null;
  override_description?: string | null;
  media: PreviewMedia[];
  testimonial?: { quote: string; attribution?: string | null } | null;
};

export function usePortfolioPreview() {
  const [data, setData] = useState<PreviewSlot[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      setLoading(true); setError(null);
      try {
        const json = await apiGet<PreviewSlot[]>("/api/portfolio/preview");
        setData((json ?? []).sort((a, b) => a.position - b.position));
      } catch (e: any) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, loading, error };
}